export default "__VITE_ASSET__isccc7Q5__"